import Vue from "vue";
import VueRouter from "vue-router";

import { GUIDE_KEY } from "@/utils/Constants";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  //삭제 예정 임시
  {
    path: "/pass/open",
    name: "PassOpen",
    component: () => import("@/views/pass/PassOpen.vue")
  },
  // 패스 인증
  {
    path: "/pass/callback",
    name: "PassCallback",
    component: () => import("@/views/pass/PassCallback.vue"),
    meta: { hasNotAuthCheck: true, keepAlive: false }
  },
  {
    path: "/error/service",
    name: "ServiceError",
    component: () => import("@/views/error/serviceError"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/Login")
  },
  {
    path: "/zocbo/callback",
    name: "zocboCallback",
    component: () => import("@/views/login/ZocboCallback"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/wordmaster/profile/complete",
    name: "WordMasterCompleteProfile",
    component: () => import("@/views/login/WordMasterCompleteProfile")
  },
  {
    path: "/auth/sso",
    name: "SsoCertify",
    component: () => import("@/views/login/SsoCertify")
  },
  {
    path: "/auth/seoulrun",
    name: "SeoulrunAuth",
    component: () => import("@/views/seoulrun/SeoulrunAuth")
  },
  {
    path: "/login/password/change",
    name: "PeriodicPasswordChange",
    component: () => import("@/views/login/PeriodicPasswordChange")
  },
  {
    path: "/naver/callback",
    name: "naverCallback",
    component: () => import("@/views/login/NaverCallback"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/account/withdrawal",
    name: "AccountWithdrawal",
    component: () => import("@/views/login/AccountWithdrawal")
  },
  {
    path: "/account/withdrawal/:type",
    name: "AccountWithdrawalType",
    component: () => import("@/views/login/AccountWithdrawal")
  },
  {
    path: "/account/use",
    name: "AccountUse",
    component: () => import("@/views/login/AccountNotUse")
  },
  {
    path: "/account/lock",
    name: "AccountLock",
    component: () => import("@/views/login/AccountLock")
  },
  {
    path: "/account/wakeup",
    name: "WakeupDormant",
    component: () => import("@/views/login/WakeupDormant")
  },
  {
    path: "/account/wakeup/:type",
    name: "WakeupDormantType",
    component: () => import("@/views/login/WakeupDormant")
  },
  // 회원가입 - 통합
  {
    path: "/signup/integrated",
    name: "IntegratedRegister",
    component: () => import("@/views/register/IntegratedRegister.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/terms/integrated",
    name: "IntegratedRegisterTerms",
    component: () => import("@/views/register/IntegratedTermAgree.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/terms",
    name: "RegisterTerms",
    component: () => import("@/views/register/TermAgree.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/integrated/method",
    name: "IntegratedRegisterMethod",
    component: () => import("@/views/register/IntegratedRegisterMethod.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/method",
    name: "RegisterMethod",
    component: () => import("@/views/register/RegisterMethod.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/integrated/account-certification",
    name: "IntegratedAccountCertification",
    component: () => import("@/views/register/IntegratedAccountCertification.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/account-certification",
    name: "AccountCertification",
    component: () => import("@/views/register/AccountCertification.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/integrated/account-info",
    name: "IntegratedAccountInformation",
    component: () => import("@/views/register/IntegratedAccountInformation.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/account-info",
    name: "AccountInformation",
    component: () => import("@/views/register/AccountInformation.vue")
  },
  {
    path: "/signup/service",
    name: "ServicedRegister",
    component: () => import("@/views/register/ServicedRegister.vue")
  },
  {
    path: "/signup/service/restrictions",
    name: "ServicedRegisterRestrictions",
    component: () => import("@/views/register/ServicedRegisterRestrictions.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/serviced/terms",
    name: "ServicedRegisterTerms",
    component: () => import("@/views/register/ServicedTermAgree.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/service/terms",
    name: "ServiceRegisterTerms",
    component: () => import("@/views/register/ServiceTermAgree.vue")
  },
  {
    path: "/register/question-talk/terms",
    name: "QuestionTalkTermsAgree",
    component: () => import("@/views/register/QuestionTalkTermsAgree.vue")
  },
  {
    path: "/register/serviced/check",
    name: "ServicedRegisterCheck",
    component: () => import("@/views/register/ServicedRegisterCheck.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/serviced/user-type",
    name: "ServicedRegisterUserType",
    component: () => import("@/views/register/ServicedUserType.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/service/user-type",
    name: "ServiceRegisterUserType",
    component: () => import("@/views/register/ServiceUserType.vue")
  },
  {
    path: "/register/serviced/terms/eci",
    name: "ServicedEtoosECITermAgree",
    component: () => import("@/views/register/ServicedEtoosECITermAgree.vue")
  },
  {
    path: "/register/serviced/terms/elifun",
    name: "ServicedEtoosElifunTermAgree",
    component: () => import("@/views/register/ServicedEtoosElifunTermAgree.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/register/serviced/complete",
    name: "ServicedComplete",
    component: () => import("@/views/register/ServicedComplete.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/register/complete",
    name: "RegisterComplete",
    component: () => import("@/views/register/Complete.vue")
  },
  {
    path: "/transfer/register",
    name: "TransferRegister",
    component: () => import("@/views/transfer/register/Register.vue")
  },
  {
    path: "/transfer/terms",
    name: "TransferRegisterTerms",
    component: () => import("@/views/transfer/register/TermsAgree.vue")
  },
  {
    path: "/transfer/method",
    name: "TransferRegisterMethod",
    component: () => import("@/views/transfer/register/RegisterMethod.vue")
  },
  {
    path: "/transfer/account-certification",
    name: "TransferAccountCertification",
    component: () => import("@/views/transfer/register/AccountCertification.vue")
  },
  {
    path: "/transfer/account-info",
    name: "TransferAccountInfo",
    component: () => import("@/views/transfer/register/AccountInfo.vue")
  },
  {
    path: "/transfer/register/complete",
    name: "TransferRegisterComplete",
    component: () => import("@/views/transfer/register/RegisterComplete.vue")
  },
  {
    path: "/transfer/gate",
    name: "TransferGate",
    component: () => import("@/views/transfer/auth/TransferGate.vue")
  },
  {
    path: "/transfer/account/integrate",
    name: "TransferAccountInfoToIntegrate",
    component: () => import("@/views/transfer/auth/TransferAccountInfoToIntegrate.vue")
  },
  {
    path: "/transfer/account/service",
    name: "TransferAccountInfoToService",
    component: () => import("@/views/transfer/auth/TransferAccountInfoToService.vue"),
    props: true
  },
  {
    path: "/transfer/account/certify",
    name: "TransferAccountCertify",
    component: () => import("@/views/transfer/auth/TransferAccountCertify.vue"),
    props: true
  },
  {
    path: "/transfer/account/certify/complete",
    name: "TransfeCertifyCompleteFromAccount",
    component: () => import("@/views/transfer/auth/TransfeCertifyCompleteFromAccount.vue")
  },
  {
    path: "/transfer/sns/certify",
    name: "TransferSnsCertifyComplete",
    component: () => import("@/views/transfer/auth/TransferSnsCertifyComplete.vue"),
    props: true
  },
  {
    path: "/transfer/sns/account/login",
    name: "TransferSnsAccountLogin",
    component: () => import("@/views/transfer/auth/TransferSnsAccountLogin.vue")
  },
  {
    path: "/transfer/id/suggestion",
    name: "TransferIdSuggestion",
    component: () => import("@/views/transfer/TransferIdSuggestion"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/transfer/member/checking",
    name: "TransferMemberChecking",
    component: () => import("@/views/transfer/TransferMemberChecking"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/error/404",
    name: "notFound",
    component: () => import("@/views/error/NotFound"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/views/error/MaintenanceGuide"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/mypage/gate/:type",
    name: "MypageGate",
    component: () => import("@/views/mypage/MypageGate.vue")
  },
  {
    path: "/mypage/profile",
    name: "MypageProfileGate",
    component: () => import("@/views/mypage/MypageProfileGate.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/id",
    name: "IntegratedInfoId",
    component: () => import("@/views/mypage/info/IntegratedInfoId.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/profile/contact",
    name: "ContactManagerment",
    component: () => import("@/views/mypage/info/ContactManagerment.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/security",
    name: "AccountSecurity",
    component: () => import("@/views/mypage/security/AccountSecurity.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/change/password",
    name: "ChangePassword",
    component: () => import("@/views/mypage/security/ChangePassword.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/integrated",
    name: "IntegratedMembersip",
    component: () => import("@/views/mypage/IntegratedMembersip.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/integrated/account/info",
    name: "IntegratedMembersipAccountInfo",
    component: () => import("@/views/mypage/info/AccountInfo.vue")
  },
  {
    path: "/mypage/integrated/account/profile",
    name: "IntegratedMembersipAccountProfile",
    component: () => import("@/views/mypage/info/AccountIntegratedProfile.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/withdraw/service",
    name: "ServiceWithdraw",
    component: () => import("@/views/mypage/withdraw/ServiceWithdraw.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/integrated/account/service",
    name: "IntegratedMembersipAccountService",
    component: () => import("@/views/mypage/info/AccountService.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/integrated/account/setting",
    name: "IntegratedMembersipAccountSetting",
    component: () => import("@/views/mypage/info/AccountSetting.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/skygo/info",
    name: "SkygoServicedInfo",
    component: () => import("@/views/mypage/info/SkytabServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/linker/info",
    name: "MypageLinkerServicedInformation",
    component: () => import("@/views/mypage/info/LinkerServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/curi/info",
    name: "MypageCuriServicedInformation",
    component: () => import("@/views/mypage/info/CuriServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/etoos/info",
    name: "MypageEtoosServicedInformation",
    component: () => import("@/views/mypage/info/EtoosServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/moji/info",
    name: "MypageMojiServicedInfomation",
    component: () => import("@/views/mypage/info/MojiServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/serviced/wordmaster/info",
    name: "MypageWordMasterServicedInfomation",
    component: () => import("@/views/mypage/info/WordMasterServicedInformation"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    // 디온 마이페이지 프로필
    path: "/mypage/serviced/dion/info",
    name: "MypageDionServicedInformation",
    component: () => import("@/views/mypage/info/DionServicedInformation.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/mypage/withdraw",
    name: "Withdraw",
    component: () => import("@/views/mypage/withdraw/Withdraw.vue"),
    meta: { hasMypageAuthCheck: true }
  },
  {
    path: "/account/find/integrated",
    name: "FindIntegratedAccount",
    component: () => import("@/views/account/FindIntegratedAccount.vue")
  },
  {
    path: "/account/find/existing",
    name: "FindExistingAccount",
    component: () => import("@/views/account/FindExistingAccount.vue")
  },
  {
    path: "/account/find/selector",
    name: "FindAccountSelector",
    component: () => import("@/views/account/FindAccountSelector.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/account/find",
    name: "FindAccountGatePage",
    component: () => import("@/views/account/FindAccountGatePage.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/find/account",
    name: "FindAccountGate",
    component: () => import("@/views/account/FindAccountGate.vue")
  },
  {
    // 리팩토링 후 삭제 예정
    path: "/find/etoos/account/:type",
    name: "FindEtoosAccount",
    component: () => import("@/views/account/FindEtoosAccount.vue")
  },
  {
    // 리팩토링 후 아래 화면으로만 사용 예정
    path: "/find/account/:type",
    name: "FindAccount",
    component: () => import("@/views/account/FindAccount.vue")
  },
  {
    // 워드마스터 아이디/비밀번호 찾기
    path: "/find/account/wordmaster/:type",
    name: "FindAccountWordmaster",
    component: () => import("@/views/account/FindAccountWordmaster.vue")
  },
  {
    path: "/change/etoos/account/password",
    name: "ChangeEtoosAccountPassword",
    component: () => import("@/views/account/ChangeEtoosAccountPassword.vue")
  },
  {
    path: "/find/etoos/account/complete/:type",
    name: "FindEtoosAccountComplete",
    component: () => import("@/views/account/FindEtoosAccountComplete.vue")
  },
  {
    path: "/account/find/password",
    name: "FindIntegratedAccountPassword",
    component: () => import("@/views/account/FindIntegratedAccountPassword.vue"),
    props: true
  },
  {
    path: "/terms/:type",
    name: "TermsSingle",
    component: () => import("@/views/terms/Privacy"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/terms/:type/:pageType",
    name: "Terms",
    component: () => import("@/views/terms/Privacy"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/notice/integrated/account",
    name: "NoticeIntegratedEtoosAccount",
    component: () => import("@/views/register/etoos/NoticeIntegratedEtoosAccount"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/resolve/duplicated/account",
    name: "ResolveDuplicatedEtoosAccount",
    component: () => import("@/views/register/etoos/ResolveDuplicatedEtoosAccount"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/verify/account",
    name: "VerifyEtoosAccount",
    component: () => import("@/views/register/etoos/VerifyEtoosAccount"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/change/password",
    name: "ChangeEtoosPassword",
    component: () => import("@/views/register/etoos/ChangeEtoosPassword"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/integration/notice",
    name: "IntegrationNotice",
    component: () => import("@/views/terms/IntegrationNotice"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/withdraw",
    name: "WithdrawGuide",
    component: () => import("@/views/terms/Withdraw"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/logout",
    name: "PortalLogout",
    component: () => import("@/views/logout/PortalLogout"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/token/conversion",
    name: "TokenConversion",
    component: () => import("@/views/login/TokenConversion.vue"),
    meta: { hasNotAuthCheck: true }
  },
  {
    path: "/firewall/timeout",
    name: "TimeoutGuide",
    component: () => import("@/views/error/TimeoutGuide"),
    meta: { hasNotAuthCheck: true }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  const info = to.matched.some((obj) => {
    return obj.meta.hasNotAuthCheck;
  });

  if (from.name === "TransferMemberChecking" && to.name === "Login") {
    next();
  } else if (!to.matched.length) {
    next({ name: "notFound" });
  } else if (!info) {
    const clientId = to.query[GUIDE_KEY.GUIDE_CLIENT_ID];

    if (typeof clientId === "undefined" || clientId === null) {
      next({ name: "ServiceError" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
